import React from 'react';
import {
    Text,
    View,
    StyleSheet,
    TouchableWithoutFeedback,
} from 'react-native';
import Theme from '../../theme';
import {
    StarIcon,
    ScreenMirrorIcon,
    ScreenSelectionIcon,
    AirplayIcon,
    SlideUpOrDownIcon
} from '../../ui/components/Icons';

const WifiMirroring = (props) => {
    const {
        availableTabs,
        setActiveTab,
        routes,
        jumpToIndex,
        currentTabIndex,
    } = props;
    return (
        <View style={styles.container}>
            <View style={styles.singleInstructionContainer}>
                <SlideUpOrDownIcon width={25} height={25} />
                <Text style={styles.instructionText}>
                    <Text style={{ fontFamily: Theme.Custom700 }}>
                        Swipe up or down {" "}
                    </Text>
                    on your screen to reveal your device’s Quick Settings menu (also called Control Centre).
                </Text>
            </View>
            <View style={styles.singleInstructionContainer}>
                <ScreenMirrorIcon width={25} height={25} />

                <Text style={styles.instructionText}>
                    Tap the
                <Text style={{ fontFamily: Theme.Custom700 }}>{" "} Screen Mirroring {" "}</Text>
                button (also called Cast Screen or Smart View on some phones).
                </Text>
            </View>
            <View style={styles.singleInstructionContainer}>
                <ScreenSelectionIcon width={25} height={25} />
                <Text style={styles.instructionText}>
                    <Text style={{ fontFamily: Theme.Custom700 }}>Select the screen {" "}</Text>
                    you want to use for your workout.</Text>
            </View>
            <View style={styles.singleInstructionContainer}>
                <StarIcon width={25} height={25} />
                <Text style={styles.instructionText}>
                    <Text style={{ fontFamily: Theme.Custom700 }}>
                        Swipe down {" "}
                    </Text>to return to Fitbeat.</Text>
            </View>
        </View>
    );
};

WifiMirroring.propTypes = {
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'column',
    },
    singleInstructionContainer: {
        flex: 1,
        flexDirection: 'row',
        height: 60,
        padding: 3,
        borderWidth: 0,
        borderBottomWidth: 1,
        borderColor: Theme.GREY_LIGHT,
        alignItems: 'center',
    },
    instructionText: {
        flex: 1,
        fontSize: 16,
        color: Theme.BLACK,
        paddingHorizontal: 10
    },
});

export default WifiMirroring;
